import React from 'react';
import styled from 'styled-components/macro';

export const SignUpStep = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	width: 90%;
	max-width: 51.25rem;
	margin: 0 auto;
`;

SignUpStep.displayName = 'SignUpStep';

export const SignUpHeader = styled.div<{ small?: boolean }>`
	width: 100%;
	line-height: 1.25;
	padding-right: ${({ small }) => (small ? '23%' : 0)};

	${({ theme }) => theme.mediaQueries.mobile} {
		padding-right: 0;
	}
`;

SignUpHeader.displayName = 'SignUpHeader';

type SignUpWrapperProps = {
	children: React.ReactNode;
};

export const SignUpWrapper = ({ children }: SignUpWrapperProps) => (
	<div className="mx-auto mt-contentLarge flex max-w-[51.25rem] flex-col px-contentSmall">
		{children}
	</div>
);

export const SignUpWrapperInner = ({ children }: SignUpWrapperProps) => (
	<div className="max-w-md">{children}</div>
);
